<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col col="9" sm="9" md="6" lg="3">
          <v-autocomplete
            v-model="selectedStudents"
            chips
            deletable-chips
            small-chips
            multiple
            :items="students"
            item-text="full_name_2"
            item-value="user_id"
            label="Select Students"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col col="9" sm="9" md="6" lg="3"> Progress Report </v-col>
        <v-col col="9" sm="3" md="2" lg="1">
          <v-btn color="primary" @click="printProgressReport"> PDF </v-btn>
        </v-col>
      </v-row>
      <div class="text-center">
        <v-snackbar v-model="snackbar">
          {{ snackbarText }}
          <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-container>
  </v-app>
</template>

<script>
export default {
  props: {
    students: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedStudents: [],
      snackbar: false,
      snackbarText: null,
    };
  },
  methods: {
    printProgressReport() {
      window.open(
        process.env.VUE_APP_API_URL +
          `/my-schedule/print-grading-report?students=${this.selectedStudents}`,
        "_blank"
      );
    },
  },
};
</script>
